import { useEffect } from 'react'

interface useInitModelsProps {
  getRows: Function
  setRows: Function
  setDeleteEntryId: Function
  setShowModal: Function
  setShowOverlay: Function
}

const useInit = (props: useInitModelsProps) => {
  useEffect(() => {
    props
      .getRows({
        setDeleteEntryId: props.setDeleteEntryId,
        setShowModal: props.setShowModal,
      })
      .then((data: any) => {
        props.setRows(data)
        props.setShowOverlay(false)
      })
  }, [])
}

export default useInit
